export interface TextEdit {
  /** Start of the removed range, in `previous` coordinates. */
  start: number;
  /** End (exclusive) of the removed range, in `previous` coordinates. */
  end: number;
  /** Text inserted in place of the removed range. */
  inserted: string;
}

const commonPrefixLength = (previous: string, next: string): number => {
  const max = Math.min(previous.length, next.length);
  let length = 0;
  while (length < max && previous[length] === next[length]) length += 1;
  return length;
};

const commonSuffixLength = (previous: string, next: string, reserved: number): number => {
  const max = Math.min(previous.length, next.length) - reserved;
  let length = 0;
  while (length < max && previous[previous.length - 1 - length] === next[next.length - 1 - length]) length += 1;
  return length;
};

export const diffText = (previous: string, next: string): TextEdit => {
  const prefix = commonPrefixLength(previous, next);
  const suffix = commonSuffixLength(previous, next, prefix);
  return {start: prefix, end: previous.length - suffix, inserted: next.slice(prefix, next.length - suffix)};
};
